<template>
<v-card
    class="pa-4 ma-0"
    elevation="4"
  >
    <h1>Daily Staking Percentage</h1>
    <ul class="mb-5">
      <li>Daily distribution of the staking percentage</li>
    </ul>

    <div
      v-if="graphLoading"
      class="text-center"
    >
      <v-progress-circular
        indeterminate
        size="60"
        width="10"
        color="#FF14B0"
        class="my-5"
      ></v-progress-circular>
      <p>
        Loading Graph...
      </p>
    </div>

    <highcharts :options="chartOptions"></highcharts>

  </v-card>
</template>

<script>
  import {
    Chart
  } from "highcharts-vue";

  import {
    dayToDate
  } from '../utils/helpers.js';

  import Highcharts from "highcharts";
  import HighchartsMore from "highcharts/highcharts-more";
  import dark from "highcharts/themes/dark-unica";

  HighchartsMore(Highcharts);
  dark(Highcharts);

  Highcharts.setOptions({
    colors: ['#3c44b1', '#33b1f6', '#29abb5', '#ffdc00']
  });

  import {
    mapState
  } from 'vuex';

  export default {
    name: 'SupplyGraph',
    data() {
      return {
        data: [],
        graphLoading: false,
        chart: null,
        interval: 60,
        chartOptions: {
          chart: {
            type: 'area',
            backgroundColor: null,
            zoomType: 'x',
            panning: true,
            panKey: 'shift',
            style: {
              fontFamily: "Roboto, sans-serif"
            }
          },
          title: {
            text: ''
          },
          subtitle: {
            text: 'Click and drag to zoom in. Hold shift to pan.'
          },
          credits: {
            text: 'wiseinfo.io',
            href: "https://wiseinfo.io",
            style: {
              fontSize: "12px",
              color: "#aaaaaa"
            },
            position: {
              x: -20,
              y: -20
            }
          },
          tooltip: {
            backgroundColor: '#555555',
            borderRadius: 10,
            borderWidth: 1,
            shared: true,
            split: false,
            pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.percentage:.1f}%</b> ({point.y:,.0f} WISE)<br/>',
          },
          xAxis: [{
            categories: [],
            tickmarkPlacement: 'on',
            title: {
              text: 'Wise Day',
              enabled: true
            },
            plotLines: []
          }],
          yAxis: {
            title: {
              text: 'WISE',
              style: {
                color: Highcharts.getOptions().colors[1]
              },
            },
            labels: {
              format: '{value}%',
              style: {
                color: Highcharts.getOptions().colors[1]
              }
            },
            plotLines: []
          },
          legend: {
            enabled: true
          },
          plotOptions: {
            area: {
              stacking: 'percent',
              lineWidth: 1,
              marker: {
                enabled: false,
                lineWidth: 1,
              },
            }
          },
          series: [{
            name: 'Liquid WISE',
            color: Highcharts.getOptions().colors[2],
            data: []
          }, {
            name: 'Staked WISE',
            color: Highcharts.getOptions().colors[1],
            data: []
          }],
          responsive: {
            rules: [{
              condition: {
                maxWidth: 600
              },
              chartOptions: {
                yAxis: [{
                    labels: {
                      enabled: false
                    },
                    title: {
                      text: null
                    }
                  },
                  {
                    labels: {
                      enabled: false
                    },
                    title: {
                      text: null
                    }
                  },
                  {
                    labels: {
                      enabled: false
                    },
                    title: {
                      text: null
                    }
                  },
                  {
                    labels: {
                      enabled: false
                    },
                    title: {
                      text: null
                    }
                  }
                ]
              }
            }]
          }
        }
      }
    },
    components: {
      highcharts: Chart
    },
    created() {
      this.generateData();
    },
    computed: {
      ...mapState({
        dailySupply: state => state.dailySupply,
      }),
    },
    watch: {
      dailySupply() {
        this.generateData();
      },
    },
    methods: {

      receivedAllNeededData() {
        return (
          this.$store.state.dailySupply.length > 0
        );
      },

      generateData() {
        if (!this.receivedAllNeededData()) {
          return;
        }
        this.graphLoading = true;

        let dailySupply = this.$store.state.dailySupply;

        // this.chartOptions.series[0].data = allPenalties;

        // let startDay = 51;
        // let daysArray = Array.from({
        //   length: this.$store.state.currentWiseDay - startDay + 1
        // }, (_, i) => "Day " + (i + startDay));
        // this.chartOptions.xAxis[0].categories = daysArray
        this.chartOptions.xAxis[0].categories = dailySupply.map(day => dayToDate(day.day) + " (Day " + day.day + ")");
        this.chartOptions.series[0].data = dailySupply.map(day => day.supplies.liquidWiseSupply);
        this.chartOptions.series[1].data = dailySupply.map(day => day.supplies.stakedWiseSupply);

        // let cumulativeSum = allPenalties.map((sum => value => sum += value)(0));

        // this.chartOptions.series[1].data = cumulativeSum;

        this.graphLoading = false;
      },
    },
  }
</script>

<style >

</style>
